module.exports = __webpack_public_path__ + "img/multiplication-table-inactive.ff83d15a.png";